module.exports = __webpack_public_path__ + "img/dna.6b44564f.svg";